import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Paper from '@material-ui/core/Paper';
import Modal from '@material-ui/core/Modal';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Header from '../../components/Header';
import MenuDrawer from '../../components/MenuDrawer';
import SearchButton from '../../components/atoms/SearchButton';
import ShopRegisterButton from '../../components/atoms/ShopRegisterButton';
import BackButton from '../../components/atoms/BackButton';
import GroupShopTable from '../organisms/GroupShopTable';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import { getShops } from '../../actions/Shop';
import { getGroupDetail } from '../../actions/Groups';
import { getAccounts } from '../../actions/Accounts';
import ShopAddAdmin from '../organisms/ShopAddAdmin';

const styles = {
  root: {
    backgroundColor: '#e0e0e0',
    flexGrow: 1,
    width: '100%'
  },
  pageTitileDiv: {
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  mainPaper: {
    position: 'relative',
    margin: 20
  },
  zoom: {
    position: 'relative',
    left: -10,
    top: 20
  },
  mainPaperTitleDiv: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '20px 26px 10px 26px'
  },
  searchForm: {
    padding: '10px 26px 10px 26px'
  },
  formFlex: {
    display: 'flex',
    alignItems: 'center'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '300px'
  },
  textField150: {
    padding: '0px 5px 0px 5px',
    width: '200px'
  },
  groupName: {
    marginLeft: '15px'
  },
  button: {
    margin: '5px 5px'
  },
  buttonLeft: {
    textAlign: 'left'
    // CSV出力ボタンを実装時にコメントアウトを外す
    // float: 'left'
  },
  buttonGroupLeft: {
    textAlign: 'left',
    float: 'left'
  },
  buttonRight: {
    textAlign: 'right'
  },
  buttonGroupRight: {
    textAlign: 'right'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      shops: state.shops.shops,
      groupDetail: state.groups.detail
    }),
    dispatch => ({
      actions: bindActionCreators(
        { getShops, getGroupDetail, getAccounts },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openModal', 'updateOpenModal', false),
  withState('openEditModal', 'updateOpenEditModal', false),
  withState('openDetailModal', 'updateOpenDetailModal', false),
  withState('openDelete', 'updateOpenDelete', false),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openTable', 'updateOpenTable', false),
  withState('openShopAdd', 'updateOpenShopAdd', false),
  withState('openShopAddConfirm', 'updateOpenShopAddConfirm', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('groupId', 'setGroupId', ''),
  withState('shopName', 'setShopName', ''),
  withState('unnarrowDownGroup', 'setUnnarrowDownGroup', true),
  withState('groupName', 'setGroupName', ''),
  withState('cityId', 'setCityId', ''),
  withState('address', 'setAddress', ''),
  withState('depositManage', 'setDepositManage', ''),
  withState('page', 'setPage', 1),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('paymentGroupType', 'setPaymentGroupType', ''),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleRedirect: props => path => {
      props.history.push(path);
    },
    handleChangePage: props => async (event, page, limit) => {
      const table = document.getElementById('scrollTableId');
      if (table !== null) {
        table.scrollTop = 0;
      }
      props.setPage(page);

      const rowsPerPage = document.getElementById('rowsPerPage');
      let limitNum = 100;
      if (rowsPerPage) {
        limitNum = rowsPerPage.textContent;
      }

      const searchKey = {
        groupId: props.groupId,
        shopName: props.shopName,
        address: props.address,
        unnarrowDownGroup: props.unnarrowDownGroup,
        page,
        limit: limit || limitNum
      };

      props.updateLoading(true);
      props.updateOpenProgress(true);
      await props.actions
        .getShops(searchKey)
        .then(data => {
          if (data.error === true && data.payload.status === 403) {
            sendLogin(props);
          }
          props.updateOpenProgress(false);
          props.updateLoading(false);
          props.updateOpenTable(true);
        })
        .catch(() => {
          props.updateOpenProgress(false);
          props.updateLoading(false);
        });
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      this.props.actions
        .getAccounts({ cognitoUserId: '' })
        .then(data => this.props.checkSession(data));
      this.props.setGroupId(this.props.groupDetail.groupId);
      this.props.setGroupName(this.props.groupDetail.groupName);
      this.props.setDepositManage(this.props.groupDetail.depositManage);
      this.props.setPaymentGroupType(this.props.groupDetail.paymentGroupType);
    }
  })
);

const Main = enhance(
  ({
    classes,
    account,
    handleRedirect,
    handleChangePage,
    openDrawer,
    updateOpenDrawer,
    openTable,
    updateOpenTable,
    openShopAdd,
    updateOpenShopAdd,
    openShopAddConfirm,
    updateOpenShopAddConfirm,
    loading,
    openProgress,
    groupId,
    shopName,
    setShopName,
    cityId,
    setCityId,
    address,
    setAddress,
    unnarrowDownGroup,
    groupName,
    depositManage,
    paymentGroupType,
    page
  }) => {
    const isShop = typeof account !== 'undefined' && account.role === 'SHOP';
    const isGroup = typeof account !== 'undefined' && account.role === 'GROUP';
    const isSecretariat =
      typeof account !== 'undefined' && account.role === 'SECRETARIAT';
    const isDeveloper =
      typeof account !== 'undefined' && account.role === 'DEVELOPER';
    const roles = {
      isShop,
      isGroup,
      isSecretariat,
      isDeveloper
    };

    const rowsPerPage = document.getElementById('rowsPerPage');
    let limitNum = 100;
    if (rowsPerPage) {
      limitNum = rowsPerPage.textContent;
    }

    const searchKey = {
      groupId,
      shopName,
      address,
      unnarrowDownGroup,
      page,
      limit: limitNum
    };
    const groupShop = true;

    const searchAction = async () => {
      updateOpenTable(true);
      handleChangePage(null, 1, limitNum);
      // updateLoading(true);
      // updateOpenProgress(true);
      // await actions
      //   .getShops(searchKey)
      //   .then(data => {
      //     checkSession(data);
      //     updateOpenProgress(false);
      //     updateLoading(false);
      //     handleChangePage(null, 0);
      //     updateOpenTable(true);
      //   })
      //   .catch(() => {
      //     updateOpenProgress(false);
      //     updateLoading(false);
      //   });
    };
    const registerOpenAction = () => updateOpenShopAdd(true);
    const shopCancelAction = () => updateOpenShopAdd(false);
    const shopBackAction = () => updateOpenShopAddConfirm(false);
    const backAction = () => handleRedirect('/groups');
    console.log(paymentGroupType);
    return (
      <div className={classes.root}>
        <Header
          onMenuClick={() => {
            updateOpenDrawer(true);
          }}
        />
        <Drawer
          open={openDrawer}
          anchor="left"
          onClose={() => {
            updateOpenDrawer(false);
          }}
        >
          <div tabIndex={0} role="button">
            <MenuDrawer account={account} />
          </div>
        </Drawer>
        <div className={classes.pageTitileDiv}>
          <Typography variant="h6" color="textSecondary">
            グループ店舗検索
          </Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <div className={classes.searchForm}>
            <div className={classes.formFlex}>
              {(roles.isGroup || roles.isSecretariat || roles.isDeveloper) && (
                <TextField
                  label="店舗名"
                  placeholder="部分一致"
                  type="search"
                  className={classes.textField}
                  margin="normal"
                  value={shopName}
                  onChange={e => {
                    setShopName(e.target.value);
                  }}
                />
              )}
              {(roles.isGroup || roles.isSecretariat || roles.isDeveloper) && (
                <TextField
                  label="住所"
                  placeholder="部分一致"
                  type="search"
                  className={classes.textField}
                  margin="normal"
                  value={address}
                  onChange={e => {
                    setAddress(e.target.value);
                  }}
                />
              )}
              <Typography
                component="p"
                variant="h6"
                color="textSecondary"
                className={classes.groupName}
              >
                {groupName}
              </Typography>
            </div>
            {(roles.isGroup || roles.isSecretariat || roles.isDeveloper) && (
              <div>
                <div className={classes.buttonGroupLeft}>
                  <SearchButton onClickAction={searchAction} />
                </div>
                <div className={classes.buttonGroupRight}>
                  <span className={classes.buttonRight}>
                    <ShopRegisterButton onClickAction={registerOpenAction} />
                  </span>
                </div>
              </div>
            )}
          </div>
          {openTable && (
            <GroupShopTable
              roles={roles}
              searchKey={searchKey}
              page={page}
              handleChangePage={handleChangePage}
              selectedPage={page}
            />
          )}
          <div>
            <BackButton onClickAction={backAction} />
          </div>
        </Paper>
        <div>
          <Modal open={openShopAdd}>
            <ShopAddAdmin
              openShopAddConfirm={openShopAddConfirm}
              updateOpenShopAdd={updateOpenShopAdd}
              updateOpenShopAddConfirm={updateOpenShopAddConfirm}
              groupDepositManage={depositManage}
              paymentGroupType={paymentGroupType}
              cancelAction={shopCancelAction}
              backAction={shopBackAction}
              searchKey={searchKey}
              groupShop={groupShop}
              roles={roles}
              cityId={cityId}
              setCityId={setCityId}
            />
          </Modal>
        </div>
        <ProgressDialog openProgress={openProgress} loading={loading} />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
